import React from 'react';

import imgPromote from '../images/promote.png';
import imgPromoteMobile from '../images/promote--mobile.png';

const Announcement = ({ title, content }) => (
  <div className="row">
    <div className="col-12 col-pad-12" style={{ justifyContent: 'center' }}>
      <div className="promote left">
        <img className="mobile-hide" alt="" width="100%" src={imgPromote} />
        <img className="desktop--hide" alt="" width="100%" src={imgPromoteMobile} />
        <div className="promote__info">
          <h3>{title}</h3>
          <p>{content}</p>
        </div>
      </div>
    </div>
  </div>
);

export default Announcement;
